import { TotalResultsCount } from '@app/core/components/TotalResultsCount';
import { CopyUrlButton } from '@app/core/list-view/actions/CopyUrlButton';
import { Box } from '@mui/material';
import { useReportCtx } from '../../../report-ctx';
import { DownloadReportBtn } from './DownloadReportBtn';
import { ResetReportBtn } from './ResetReportBtn';
import { VisualizeReportBtn } from './VisualizeReportBtn';

/**
 * Report actions: Visualize, Reset on the left (with result count when result has total); copy URL and Download on the right.
 */
export const ReportActions = () => {
  const ctx = useReportCtx();

  return (
    <Box className="mt-2" sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <VisualizeReportBtn />
          <ResetReportBtn />
        </Box>
        <TotalResultsCount count={ctx.resultCount} isLoading={ctx.isLoading} />
      </Box>
      <Box sx={{ display: 'flex', gap: 1.5 }}>
        <CopyUrlButton />
        {ctx.allowDownload && <DownloadReportBtn />}
      </Box>
    </Box>
  );
};
